<template>
	<v-card>
		<stepper ref="stepper" />
	</v-card>
</template>

<script>
import Stepper from "./components/Stepper";
import Prepare from "./components/alexa/Prepare";
import Pair from "./components/alexa/Pair";
import wizardBase from "./extends/wizard";

export default {
	components: { Stepper },

	mixins: [wizardBase],

	props: { device: Object },

	data: () => ({
		type: "alexa",
		defaultConfig: {
			steps: [
				{
					title: "Prepare for Pairing",
					text: "Make sure the Alexa's wifi is configured",
					component: Prepare,
				},
				{
					title: "Pair the Device",
					text: "Start pairing now",
					component: Pair,
				},
			],
		},
	}),
};
</script>
